import { Routes, RouterModule } from '@angular/router';
import { MessageLayoutComponent } from './layouts/';
import { LoadingComponent} from './pages/';
import { PageNotFoundComponent } from './errors/';
import { PagesURLs } from './pages/pages.url';
import { Outlets } from './layouts/layouts.outlet';
import { ErrorsURLs } from './errors/errors.url';


const routes: Routes = [
  { path: PagesURLs._BLANK, component: LoadingComponent },
  { path: PagesURLs._INDEX_HTML, redirectTo: PagesURLs._BLANK, pathMatch: 'full' },
  { path: ErrorsURLs._ALL, component: MessageLayoutComponent, children: [
    { path: ErrorsURLs._BLANK, component: PageNotFoundComponent, outlet: Outlets.MESSAGE }
  ]}
];

export const AppRoutes = RouterModule.forRoot(routes, { enableTracing: false });
